import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import { FlyoutUncontrolled } from './FlyoutUncontrolled';
import { FlyoutControlled } from './FlyoutControlled';
import { FlyoutTrigger } from './FlyoutTrigger';
import { FlyoutContent } from './FlyoutContent';
const FlyoutBase = (props, ref) => {
    const { active } = props;
    if (typeof active === 'boolean') {
        return _jsx(FlyoutControlled, Object.assign({}, props, { ref: ref }));
    }
    return _jsx(FlyoutUncontrolled, Object.assign({}, props, { ref: ref }));
};
export const Flyout = React.forwardRef(FlyoutBase);
Flyout.Trigger = FlyoutTrigger;
Flyout.Content = FlyoutContent;
